(function ($) {
$(document).ready(function () {
        let currentPageUrl = location.pathname;
        const getRecaptchaToken = () => {
            if (typeof grecaptcha === 'undefined') return;
            const ecologyRecaptchaSiteKey = '6LdeqToeAAAAAIvRx_cKGRwaojPeC0gnomoCDPGD';
            grecaptcha.ready(function () {
            grecaptcha.execute(ecologyRecaptchaSiteKey, { action: "" })
                .then(function (token) {
                    document.getElementById("g-recaptcha-response-ecology").value = token;
                });
            });
        }
        if (currentPageUrl.indexOf('ecology-noise-form') > -1 || currentPageUrl.indexOf('forma-za-shum') > -1) {
            getRecaptchaToken();
            // Every 90 Seconds reset token
            setInterval(function () {
                getRecaptchaToken();
            }, 90 * 1000);
        }

        //select restyle
        $('#e_signal_concerns').each(function () {
            let $this = $(this);
            let numberOfOptions = $(this).children('option').length;
            $this.addClass('select-hidden');
            $this.wrap('<div class="select"></div>');
            $this.after('<div class="select-styled"></div>');

            let $styledSelect = $this.next('div.select-styled');
            $styledSelect.text($this.children('option').eq(0).text());

            let $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);

            for (let i = 0; i < numberOfOptions; i++) {
                $('<li />', {
                    text: $this.children('option').eq(i).text(),
                    rel: $this.children('option').eq(i).val()
                }).appendTo($list);
            }

            let $listItems = $list.children('li');

            $styledSelect.click(function (e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function () {
                    $(this).removeClass('active').next('ul.select-options').hide();
                });
                $(this).toggleClass('active').next('ul.select-options').toggle();
                if ($('#select_signal_concerns').hasClass('rotated')) {
                    $('#select_signal_concerns').removeClass('rotated');
                } else {
                    $('#select_signal_concerns').addClass('rotated');
                }
            });

            $listItems.click(function (e) {
                e.stopPropagation();
                $styledSelect.text($(this).text()).removeClass('active');
                $this.val($(this).attr('rel'));
                $list.hide();
                if ($('#select_signal_concerns').hasClass('rotated')) {
                    $('#select_signal_concerns').removeClass('rotated');
                }
            });

            $(document).click(function () {
                $styledSelect.removeClass('active');
                $list.hide();
                if ($('#select_signal_concerns').hasClass('rotated')) {
                    $('#select_signal_concerns').removeClass('rotated');
                }
            });

        });

        if ($('#ecology_form').length > 0) {
            //observer for errors thrown because of the select element
            let $selectElement = $("#e_signal_concerns");
            let observer = new MutationObserver(function (mutations) {
                if (mutations) {
                    if (!($('#e_signal_concerns-error:hidden').is(':hidden'))) {
                        $('.consern').addClass('consern_margin');
                    }
                }
            });
            observer.observe($selectElement[0], {
                attributes: true,
                attributeFilter: ['class']
            });

            const { __, _x, _n, _nx } = wp.i18n;

            const ecologyForm = $('form#ecology_form');

            if (ecologyForm.length > 0) {

                const flightDate = ecologyForm.find("#e_event_date");
                flightDate.datepicker({
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: "dd/mm/yy",
                    minDate: "-1Y",
                    maxDate: "+0m +0w",
                    firstDay: 1
                });

                //regex for the event date
                $.validator.addMethod(
                    "eventDateFormat",
                    function (value, element, regexp) {
                        const re = new RegExp(regexp);
                        return this.optional(element) || re.test(value);
                    },
                    __('Wrong date format', 'sofia-airport')
                );

                //regex for the event time
                $.validator.addMethod(
                    "regexTimeFormat",
                    function (value, element) {
                        return this.optional(element) || /^([0-9]{2}:[0-9]{2})$/i.test(value);
                    },
                    __('Wrong time format', 'sofia-airport')
                );

                //regex for the phone number
                $.validator.addMethod(
                    "phoneNumberValidation",
                    function (value, element) {
                        return this.optional(element) || /^[0-9 \+\-]{6,15}$/g.test(value);
                    },
                    __('Wrong phone number format', 'sofia-airport')
                );

                //regex for the address
                $.validator.addMethod(
                    "addressValidation",
                    function (value, element) {
                        return this.optional(element) || /^[a-zA-zа-яА-ЯёЁ0-9\'\,\„\“\s\*\)\(\+\=\.\_\-\"\"\№\#]+$/gi.test(value);
                    },
                    __('Please remove the special symbols', 'sofia-airport')
                );

                //method for the select dropdown
                $.validator.addMethod(
                    "valueNotEquals",
                    function (value, element, arg) {
                        return arg !== value;
                    },
                    __('The field is required', 'sofia-airport')
                );

                ecologyForm.validate({
                    rules: {
                        e_sender_formal_title: {
                            required: true
                        },
                        e_sender_name: {
                            required: true
                        },
                        e_sender_email: {
                            required: true,
                            email: true
                        },
                        e_sender_phone: {
                            required: true,
                            phoneNumberValidation: true
                        },
                        e_sender_address: {
                            required: true,
                            addressValidation: true
                        },
                        e_event_date: {
                            required: true,
                            eventDateFormat: /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/
                        },
                        e_event_time: {
                            required: true,
                            regexTimeFormat: true
                        },
                        e_signal_concerns: {
                            valueNotEquals: "hide",
                            required: true
                        },
                        e_signal_address: {
                            required: true,
                            addressValidation: true
                        },
                        e_additional_desc: {
                            required: true,
                        },
                    },
                    submitHandler: function (form) {
                        let ecologyRequestData = {
                            'eWebsite': $('input[name=e_website]').val(),
                            'eSenderFormalТitle': $('.form-radios .item_wrapper').find(":checked").val(),
                            'eSenderName': $('input[name=e_sender_name]').val(),
                            'eSenderEmail': $('input[name=e_sender_email]').val(),
                            'eSenderPhone': $('input[name=e_sender_phone]').val(),
                            'eSenderAddress': $('input[name=e_sender_address]').val(),
                            'eEventDate': $('input[name=e_event_date]').val(),
                            'eEventTime': $('input[name=e_event_time]').val(),
                            'eSignalConcerns': $('#e_signal_concerns').find(":selected").text(),
                            'eSignalAddress': $('input[name=e_signal_address]').val(),
                            'eAdditionalDesc': $('#e_additional_desc').val(),
                        };

                        let ecologyRecaptchaResponse = $('#g-recaptcha-response-ecology').val();

                        //send search request
                        ecologyRequestData = JSON.parse(JSON.stringify(ecologyRequestData));

                        $.ajax({
                            type: "POST",
                            url: "/wp-admin/admin-ajax.php",
                            dataType: "JSON",
                            data: {
                                action: "ecology_form",
                                data: ecologyRequestData,
                                ecologyRecaptchaResponseData: ecologyRecaptchaResponse,

                            },
                            success: function (resp) {
                                // This outputs the result of the ajax request
                                if (resp.success == false) {
                                    $('#responseBox').text(resp.data);
                                } else {
                                    $('#responseBox').text(resp.data);
                                    form.reset();

                                    const signalSelect = $('#e_signal_concerns');                                    
                                    let $styledSelect = signalSelect.next('div.select-styled'); 
                                    $styledSelect.text(signalSelect.children('option').eq(0).text());
                                    
                                }
                                getRecaptchaToken();
                            },
                            error: function (errorThrown) {
                                //Returns the thrown error
                                getRecaptchaToken();
                            }
                        });
                    }
                });

                $.extend($.validator.messages, {
                    required: __('The field is required', 'sofia-airport'),
                    email: __('Please enter a valid email address', 'sofia-airport'),
                });
            }
        }
    });
})(jQuery);